import {autoFetch as fetch} from '@/utils/fetch';

// 校验 身份证号
export function checkCarId(args) {
    let params = new URLSearchParams();
    params.append('cardId', args.cardId);
    params.append('schoolId', args.schoolId);
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'common/voteTwo/checkCarId',
        method: 'post',
        data: params
    });
}

// 获取验证码
export function getCode(args) {
    let params = new URLSearchParams();
    params.append('mobile', args.mobile);
    params.append('noticeId', args.noticeId);
    params.append('schoolId', args.schoolId);

    return fetch({
        url: 'common/voteTwo/getCode',
        method: 'post',
        data: params
    });
}

// 获取招生报名tonken
export function getTonken(args) {
    let params = new URLSearchParams();
    params.append('cardId', args.cardId);
    params.append('noticeId', args.noticeId);
    params.append('mobile', args.mobile);
    params.append('schoolId', args.schoolId);
    params.append('voteId', args.voteId);
    params.append('userName', args.userName);
    if( args.birthDate) {
        params.append('birthDate', args.birthDate);
    }
    if( args.gender) {
        params.append('gender', args.gender);
    }
    params.append('cardType', args.cardType);

    return fetch({
        url: 'common/voteTwo/getTonken',
        method: 'post',
        data: params
    });
}

// 校验 验证码
export function checkCode(args) {
    let params = new URLSearchParams();
    params.append('code', args.code);
    params.append('mobile', args.mobile);
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'common/voteTwo/checkCode',
        method: 'post',
        data: params
    });
}

// 根据公告id查询公告
export function getVoteTwoRecruitNotice(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'common/voteTwo/getVoteTwoRecruitNotice',
        method: 'post',
        data: params
    });
}

// 根据招生报名用户查询问卷信息
export function getVoteByRecruitUser(args) {
    let params = new URLSearchParams();
    // params.append('token', args.token);

    return fetch({
        url: `common/voteTwo/getVoteByRecruitUser?token=${args.token}`,
        method: 'post',
        // data: params
    });
}

//招生报名用户答卷
export function addVoteTwoRecruitUserSelectedList(args) {
    let params = new URLSearchParams();
    params.append('voteTwoUserSelectedList', args.voteTwoUserSelectedList);

    return fetch({
        url: `common/voteTwo/addVoteTwoRecruitUserSelectedList?token=${args.token}`,
        method: 'post',
        data: params
    })
}

// 根据ID获得学校信息
export function queryById(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);

    return fetch({
        url: `common/school/queryById`,
        method: 'post',
        data: params
    })
}

// 校验出生日期
export function checkBirthDate(args) {
    let params = new URLSearchParams();
    params.append('birthDate', args.birthDate);
    params.append('schoolId', args.schoolId);
    params.append('noticeId', args.noticeId);

    return fetch({
        url: `common/voteTwo/checkBirthDate`,
        method: 'post',
        data: params
    })
}



// WEBPACK FOOTER //
// ./src/api/outer.js